import React from 'react';
import Input from './Input';

import './css/Search.css';

const Search = (props) => {
  const {
    onChange,
    onSubmit,
    hideDeprecated,
  } = props;

  return (
    <form onSubmit={onSubmit} onChange={onChange} className="Search">
      <p className="search__input">
        <Input
          labelText="Find a hook"
          type="search"
          id="q"
          name="q"
        />
      </p>

      <p>
        <Input
          type="checkbox"
          id="hide_deprecated"
          name="hide_deprecated"
          defaultChecked={hideDeprecated}
          labelText="Hide deprecated hooks"
        />
      </p>

      <p>
        <Input
          type="radio"
          id="show_all"
          name="by_type"
          value="all"
          labelText="Show all"
          defaultChecked
        />
      </p>

      <p>
        <Input
          type="radio"
          id="action"
          name="by_type"
          value="action"
          labelText="Show actions"
        />
      </p>

      <p>
        <Input
          type="radio"
          id="filter"
          name="by_type"
          value="filter"
          labelText="Show filters"
        />
      </p>
    </form>
  )
}

export default Search;
